import { SVGProps } from 'react'

export const Clock2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='19'
    height='19'
    viewBox='0 0 19 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M5.80762 10.8224C5.48954 10.8224 5.25098 10.5839 5.25098 10.2657C5.25098 9.95563 5.48954 9.71705 5.80762 9.71705H9.40987V4.90611C9.40987 4.59598 9.64845 4.35742 9.95856 4.35742C10.2687 4.35742 10.5152 4.59598 10.5152 4.90611V10.2657C10.5152 10.5839 10.2687 10.8224 9.95856 10.8224H5.80762ZM9.9665 18.0746C14.4037 18.0746 18.0775 14.3929 18.0775 9.96357C18.0775 5.52637 14.3958 1.85254 9.95856 1.85254C5.5293 1.85254 1.85547 5.52637 1.85547 9.96357C1.85547 14.3929 5.53725 18.0746 9.9665 18.0746Z'
      fill='currentColor'
    />
  </svg>
)
